import ActionTypes from '../constants/ActionTypes';
import api from '../constants/api';
import { authHeader } from '../helpers';
import { postApi } from '../helpers/http';

export const requestSettings = date => ({
  type: ActionTypes.REQUEST_SETTING,
  date
})

export const receiveSettings = (params, json) => ({
  type: ActionTypes.RECEIVE_SETTING,
  date: params.date,
  items: json.data,
  receivedAt: Date.now()
})

const doFetchSettings = params => async dispatch => {
  dispatch(requestSettings(params))

  const data = {
        "process_type": "getMasterList",
        "table_name": params.table_name,
        // "offset": params.offset,
        // "limit": params.limit
  };

  try {
    const json = await postApi(data);
    dispatch(receiveSettings(params, json))
  } catch (error) {
    console.error('Error:', error);
  };

  // return fetch(api.url, {
  //   method: 'POST',
  //   headers: authHeader(),
  //   body: JSON.stringify(data),
  // })
  // .then(response => response.json())
  // .then(json => {
  //   // console.log('Success:', json.data);
  //   dispatch(receiveSettings(params, json))
  // })
  // .catch((error) => {
  //   console.error('Error:', error);
  // });
}

export const fetchSettings = params => (dispatch, getState) => {
  return dispatch(doFetchSettings(params))
}

